import tokenList from './token-list';

export const wplToken = (tokenName: string) => {
  return tokenList[`${tokenName}`];
};
